import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@material-ui/core";
import CaptureArea from "../../Ocr/CaptureTextFromImage/CaptureArea";
import { DataContext } from "../../../../home/pages/automs/autom/FlowConfiguration";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
// Import Recoil
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { saveAvailable, initialActions, changedFields, activeAutom, openDesktopRecordAtom } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated, getExtension, checkTheDifference, addDifference, removeDifference } from '../../../../helpers/helper';

// Import Material UI
import Alert from '@material-ui/lab/Alert';
/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @param       setOpenVariable - open variable function that allows us to open
 * @param       variableRender - variable render
 * @param       actions - array object
 * @param       fromFlow
 * @returns     JSX.Element
 * @author      ibrahim AKIN
 */
function CropImage({
    action,
    variables,
    setOpenVariable,
    variableRender,
    actions,
    fromFlow,
    handleSave
}) {
    // const [imgCoordinate, setImgCoordinate] = useState({ coordinates: [] });
    // const [openCaptureArea, setOpenCaptureArea] = useState(false);
    const [imgCoordinate, setImgCoordinate] = useState({ coordinates: [] });
    const [openCaptureArea, setOpenCaptureArea] = useState(false);
    const [fileName, setFileName] = useState("");
    const [upImg, setUpImg] = useState();
    const [value,] = useState(0);
    const [cropImg, setCropImg] = useState("");
    const [automDetail,] = useRecoilState(activeAutom);
    //const initialActionsData = useRecoilValue(initialActions);
    //const setSaveAvailable = useSetRecoilState(saveAvailable);
    //const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const setOpenDesktopRecord = useSetRecoilState(openDesktopRecordAtom);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    let clickDiv = null;

    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.CROP-IMAGE.";

    function findScopeAction(nodes, mainNodes) {
        for (let node of nodes) {
            if ('children' in node) {
                findScopeAction(node.children, node);
            } else if (node.id === action.id) {
                if (mainNodes?.fields?.getSS || actions[mainNodes?.id]?.fields?.getSS) {
                    let getSSURL = actions[mainNodes?.id]?.fields?.getSS?.value?.length ? actions[mainNodes.id].fields.getSS.value : mainNodes.fields.getSS?.value
                    let sameURL = actions[mainNodes?.id]?.fields?.sameURL?.value?.length ? actions[mainNodes.id].fields?.sameURL?.value : mainNodes.fields.sameURL?.value
                    setUpImg(getSSURL);
                    if (action.fields.destination?.value.x === 0 &&
                        action.fields.destination?.value.y === 0) {
                        action.fields.destination = { value: { x: 0, y: 0 } };
                        action.fields.source = { value: { x: 0, y: 0 } };
                        // setImgCoordinate({ coordinates: [] });
                    }
                }
            }
        }
    }

    useEffect(() => {
        if (!action.fields.imgURL) {
            action.fields.imgURL = { value: "" };
        } else {
            setUpImg(action.fields.imgURL?.value);
        }
        if (!action.fields.completedCrop) {
            action.fields.completedCrop = { value: [] };
        } else {
            // setImgCoordinate({ coordinates: action.fields.completedCrop.value });
        }
        if (!action.fields.fileName) {
            action.fields.fileName = { value: "" };
        } else {
            setFileName(action.fields.fileName?.value);
        }
        if (!action.fields.mediaSize) {
            action.fields.mediaSize = { value: { width: 0, height: 0, div: 0 } };
        }
        if (!action.fields.gridCrop) {
            action.fields.gridCrop = { value: [] };
        }
        if (!action.fields.source) {
            action.fields.source = {
                value: { width: 0, height: 0, x: 0, y: 0, id: "asdf" },
            };
        }
        // if (!action.fields.cropImg) {
        //     action.fields.cropImg = { value: "" };
        // } else {
        //     setCropImg(action.fields.cropImg?.value);
        // }
        if (!action.fields.imagePath) {
            action.fields.imagePath = { value: "" };
        }
        if (!action.fields.destination) {
            action.fields.destination = { value: { x: 0, y: 0 } };
        }
        if (!action.fields.source) {
            action.fields.source = { value: { width: 0, height: 0, x: 0, y: 0, id: "asdf" } };
        }
        if (!action.fields.completedCropOffset) {
            action.fields.completedCropOffset = { value: [] };
        }
        let items = JSON.parse(JSON.stringify(automDetail.items))
        findScopeAction(items);
    }, [action, variables, variableRender]);

    // function resizeImage(url, width, height, x, y, arr) {
    //     const canvas = document.createElement("canvas");
    //     const context = canvas.getContext("2d");
    //     const imageObj = new Image();
    //     // set canvas dimensions
    //     canvas.width = width;
    //     canvas.height = height;

    //     imageObj.onload = function () {
    //         context.drawImage(imageObj, x, y, width, height, 0, 0, width, height);
    //         setCropImg(canvas.toDataURL());
    //     };
    //     imageObj.src = url;
    // }

    // //convert base64 to buffer byte array
    // useEffect(() => {
    //     debugger;
    //     resizeImage(
    //         upImg,
    //         action.fields.completedCrop.value[0]?.width,
    //         action.fields.completedCrop.value[0]?.height,
    //         action.fields.completedCrop.value[0]?.x,
    //         action.fields.completedCrop.value[0]?.y
    //     );
    //     if (upImg) {
    //         action.fields.cropImg = {
    //             byteValue: cropImg,
    //             value: fileName,
    //             extension: getExtension(fileName),
    //             type: "FILE",
    //         };

    //         action.fields.imagePath = action.fields.cropImg

    //     }
    // }, [
    //     action.fields,
    //     upImg,
    //     setOpenCaptureArea,
    //     openCaptureArea,
    //     cropImg,
    //     setCropImg,
    // ]);

    const changeManagement = (v) => {

        const field = initialActionsData[action.id]?.fields.completedCrop;
        const oldValue = !field ? undefined : field.value;

        CheckIfFlowUpdated('completedCrop', action, oldValue, action.fields.completedCrop.value, setSaveAvailable, setChangeFields, changedFieldsState);
        // test yapılamadı hata yaşanıyorsa aşağıdaki kod satırı aktif edilmelidir.
        //if (!oldValue) {
        //      addDifference(cfTemp, action, 'completedCrop', setChangeFields, setSaveAvailable)
        // }
        //         const cfTemp = JSON.parse(JSON.stringify(changedFieldsState));
        // const arr1 = action.fields.completedCrop.value;
        // if (oldValue) {
        //     if (checkTheDifference(arr1, oldValue, ["x","y"])) {
        //         addDifference(cfTemp, action, 'completedCrop', setChangeFields, setSaveAvailable)
        //     } else {
        //         removeDifference(cfTemp, action, 'completedCrop', setChangeFields, setSaveAvailable)
        //     }
        // }
        setOpenCaptureArea(v)
    }

    return (
        <>
            {fromFlow ?
                <div className="conf-field-container">
                    <div>
                        <Button
                            variant="outlined"
                            onClick={() => setOpenDesktopRecord(true)}
                            style={{
                                background: "#031226",
                                boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
                                borderRadius: 4,
                                color: "#fff",
                                fontWeight: 700,
                                fontSize: '11px'
                            }}
                        >
                            {t(label + "INITIATE-SELECTOR")}
                        </Button>
                    </div>
                    {openCaptureArea && (
                        <CaptureArea
                            imgCoordinate={{ coordinates: action.fields.completedCrop.value }}
                            setImgCoordinate={setImgCoordinate}
                            action={action}
                            upImg={upImg}
                            setOpenCaptureArea={(v) => changeManagement(v)}
                            setOpenVariable={setOpenVariable}
                            variables={variables}
                            isGrid={value}
                            isGetText={true}
                        />
                    )}
                </div>
                :
                <Alert severity="info" style={{ marginBottom: '20px' }}>{t('CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.GET-TEXT.INFO-MESSAGE')}</Alert>
            }
            <div className="conf-field-container">
                <FieldLabel name={t('CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.CROP-IMAGE.ASSIGN')} />
                <VariablePicker
                    action={action}
                    inputName="set"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    filter="string"
                    isRequired={false}
                />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
            {handleSave &&
                <Button
                    variant="outlined"
                    className="desktop-actions-button"
                    onClick={() => handleSave()}
                >
                    {t(label + "SAVE")}
                </Button>}
        </>
    );
}

export default CropImage;
